export default __webpack_public_path__ + "static/media/twitter.fd5cb7b9.svg";